import { typeFormDto, typeCountryDto } from "../../utils/typeDefs";
import { Button, SelectPicker, DatePicker } from "rsuite";
import { convertDate } from "../../utils/reusables";
import SearchIcon from "@rsuite/icons/Search";

type formTableProps = {
  data: typeFormDto[] | null | [];
  defaultId: number | null;
  setData: (value: typeFormDto[] | null) => void;
  addButton: string;
  currentCountryId: number | null;
  setCurrentCountryId: (value: number | null) => void;
  sortedCountryData: typeCountryDto[];
  reviewIds: number[] | [];
  search: string;
  searchData: typeFormDto[] | null;
  filter: (item: React.FormEvent<HTMLInputElement>) => void;
  setReviewDate: (value: string | null) => void;
  handleOpenModal: () => void;
  handleCheckBoxAll: (value: boolean) => void;
  applyReviewData: () => void;
};

const formRegFunctionality = ({
  setData,
  addButton,
  defaultId,
  currentCountryId,
  setCurrentCountryId,
  sortedCountryData,
  reviewIds,
  search,
  searchData,
  filter,
  setReviewDate,
  handleOpenModal,
  applyReviewData,
}: formTableProps) => {
  return (
    <>
      <div className="row gy-2 pb-2">
        <div className="col-lg-3 col-md-6 col-12 text-end">
          <SelectPicker
            disabled={searchData === null}
            data={sortedCountryData}
            onChange={(value: number | null) => {
              if (value && value !== currentCountryId) {
                setData(null);
                setCurrentCountryId(value);
              }
            }}
            onClean={() => setCurrentCountryId(defaultId)}
            placeholder="Select Country"
            valueKey={`id`}
            labelKey={`name`}
            size="md"
            className="me-2"
            block
          />
        </div>

        <div className="col-lg-3 col-md-6 col-12 ">
          <div className="input-group custom-input-group">
            <input
              disabled={searchData === null}
              type="text"
              className="form-control py-1"
              placeholder="Search"
              aria-describedby="regulations-search"
              value={search}
              onChange={filter}
            />
            <button className="btn search-button py-1" id="regulations-search">
              <SearchIcon className="search-icon ms-1" />
            </button>
          </div>
        </div>

        <div className="col-lg-6 col-md-12 col-12">
          <div className="row">
            <div className="col-lg-8 col-md-6 col-12 pb-2">
              <div className="d-flex">
                <div className="">
                  <DatePicker
                    oneTap
                    format="dd-MM-yyyy"
                    disabled={reviewIds.length === 0}
                    cleanable={false}
                    onChange={(date: Date | null) => {
                      if (date) {
                        setReviewDate(date.toDateString());
                      }
                    }}
                    renderValue={(value) => {
                      const newValue = convertDate(value.toISOString());
                      return newValue;
                    }}
                  />
                </div>
                <div className="px-2">
                  <Button
                    disabled={reviewIds.length === 0}
                    onClick={() => {
                      applyReviewData();
                    }}
                    className="primary-color apply-button"
                    appearance="primary"
                  >
                    Apply Review
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12 pb-2">
              <div className="px-2 text-end">
                <Button
                  disabled={searchData === null || currentCountryId === null}
                  onClick={() => handleOpenModal()}
                  className={"primary-color"}
                  appearance="primary"
                >
                  {addButton}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default formRegFunctionality;
